import PropTypes from 'prop-types'

import Select from 'react-select'

const SelectInput = (props) => {
  return (
    <div className="p-2">
      <label>
        {props.label}
        {props?.isRequired && <span className="text-red-700">*</span>}
      </label>
      <div className="mt-2">
        <Select
          name={props.name}
          inputName={props.name}
          classNamePrefix="dtcs-filter"
          isMulti={props.isMulti}
          value={props.value}
          options={props.options}
          placeholder={props.placeholder ? props.placeholder : props.label}
          className="w-full"
          onChange={(e) => {
            props.onChange(e)
          }}
          required={props?.isRequired}
        />
      </div>
    </div>
  )
}

SelectInput.defaultProps = {
  isMulti: false,
  isRequired: true,
  onChange: () => {},
  options: [],
}

SelectInput.propTypes = {
  className: PropTypes.string,
  isMulti: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.any,
  options: PropTypes.array,
}

export default SelectInput
